import React from 'react'

export function HolderCol ({children, className}) {
    return (
      <div className={`col-12 col-lg-5 ${className}`}> 
          {children}
      </div>
    )
  }
  